import { defaultLogo } from '../../utils/config'

export function updateStoreUrl(state, val) {
  state.storeUrl = val;
}

export function updateStoreSEO(state, val) {
  state.storeSEO = JSON.stringify(val);
}

export function updateStoreInfo(state, val) {
  if (val) val.logo = val.logo || defaultLogo;
  state.storeInfo = val;
  if (val.service) {
    val.pickUp = val.service.PICK_UP;
    val.dineIn = val.service.DINE_IN;
    val.delivery = val.service.DELIVERY;
    val.fullDineIn = val.service.FULL_DINE_IN;
  }
}

export function updateCategoryData(state, val) {
  state.categoryData = val;
}

export function updateProductData(state, val) {
  state.productData = val;
}

export function updateCartDetailsData(state, val) {
  state.cartDetailData = val;
}
// improve scroll
export function updateCategories(state, val) {
  state.categories = val;
}

// 移除一个失效商品
export function removeInvalidProductInCategory(state, product) {
  let cateIndex = 0;
  let newCate = {}
  state.categories?.some((it, itIndex) => {
    newCate = { ...it }
    cateIndex = itIndex;
    if (Array.isArray(newCate.products)) {
      const index = newCate.products.findIndex(p => p.id === product.id);
      if (index !== -1) {
        const { inStock, inList, inLive, inService, inSingleSale } = product;
        if (!inStock && inList && inService && inLive && inSingleSale) {
          newCate.products.splice(index, 1, product);
        } else {
          newCate.products.splice(index, 1);
          newCate.count -= 1;
        }
      }
      return index !== -1;
    }
    return false;
  })
  console.log(newCate);
  state.categories.splice(cateIndex, 1, newCate);
}
